import { TipoIndirizzo } from 'server/schema/integrations/pdnd/schema/schemas';

export function getCitizenAddressCity(
  address?: TipoIndirizzo
): string | undefined {
  if (!address?.comune) {
    return undefined;
  }
  return (
    (address?.comune?.nomeComune ?? '') +
    ' ' +
    (address?.comune?.descrizioneLocalita ?? '') +
    ' (' +
    (address?.comune?.siglaProvinciaIstat ?? '') +
    ')'
  );
}
